import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DarkModeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dark_mode"}/>
}
